<template>
  <el-dialog
    title="业务合作"
    :visible.sync="isVisible"
    width="60%"
    top="0"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="purchaseForm"
      :model="form"
      :rules="rules"
      label-width=""
      class="purchase-form"
    >
      <!-- 公司名称 -->
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
      </el-form-item>

      <!-- 联系方式拆分：电话 + 邮箱 -->

      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>

      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
      </el-form-item>

      <!-- 公司名称 -->
      <el-form-item label="公司名称" prop="companyName">
        <el-input
          v-model="form.companyName"
          placeholder="请输入公司名称"
        ></el-input>
      </el-form-item>

      <!-- 行业 -->
      <el-form-item label="行业" prop="industry" class="hangye">
        <el-select v-model="form.industry" placeholder="请选择行业">
          <el-option label="迎宾接待" value="welcome_reception"></el-option>
          <el-option label="酒店" value="hotel"></el-option>
          <el-option label="教育科研" value="education_research"></el-option>
          <el-option label="养老陪伴" value="elderly_care"></el-option>
          <el-option label="医疗" value="medical"></el-option>
          <el-option label="娱乐展示" value="entertainment_display"></el-option>
          <el-option label="物业安防" value="property_security"></el-option>
          <el-option label="餐饮" value="catering"></el-option>
        </el-select>
      </el-form-item>

      <!-- 客户类别 -->
      <el-form-item label="客户类别" prop="customerType" class="kehuleixing">
        <el-select v-model="form.customerType" placeholder="请选择客户类别">
          <el-option label="业主" value="owner"></el-option>
          <el-option label="集成商" value="integrator"></el-option>
          <el-option label="代理商" value="agent"></el-option>
          <el-option label="渠道商" value="distributor"></el-option>
        </el-select>
      </el-form-item>

      <!-- 感兴趣的产品（下拉选择） -->
      <el-form-item
        label="感兴趣的产品"
        prop="interestProducts"
        class="xqshangpin"
      >
        <div
          class="product-group"
          v-for="(group, index) in productGroups"
          :key="index"
        >
          <span class="group-label">{{ group.groupName }}：</span>
          <el-checkbox-group v-model="form.interestProducts">
            <el-checkbox
              v-for="product in group.products"
              :key="product.id"
              :label="product.ming"
            >
              {{ product.ming }}
            </el-checkbox>
          </el-checkbox-group>
        </div>

        <!-- 第一组：轮式人形 -->
      </el-form-item>

      <!-- 数量 -->
      <!-- <el-form-item label="数量" prop="quantity">
        <el-input
          v-model="form.quantity"
          type="number"
          min="1"
          placeholder="请输入需要的数量"
        ></el-input>
      </el-form-item> -->

      <!-- 需求描述 -->
      <el-form-item label="需求" prop="demand" class="xq">
        <el-input
          v-model="form.demand"
          type="textarea"
          :rows="3"
          placeholder="请描述您的项目需求"
        ></el-input>
      </el-form-item>

      <!-- 允许电话联系（复选框） -->
      <el-form-item class="allow">
        <el-checkbox
          v-model="form.allowContact"
          label="允许客服人员电话联系您"
        ></el-checkbox>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        @click="handleSubmit"
        style="background: linear-gradient(to right, #0081ff, #00c6ff); border: none;"
      >
        提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "PurchaseDialog",

  data() {
    // 手机号校验规则
    const validatePhone = (rule, value, callback) => {
      const reg = /^1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error("请输入联系电话"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    // 邮箱校验规则
    const validateEmail = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!value) {
        callback(new Error("请输入邮箱"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的邮箱格式"));
      } else {
        callback();
      }
    };

    // 🔥 新增：产品多选校验规则
    const validateProducts = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请至少选择一个感兴趣的产品"));
      } else {
        callback();
      }
    };

    return {
      isVisible: true,
      form: {
        name: "", // 姓名
        companyName: "", // 公司名称
        phone: "", // 联系电话
        email: "", // 邮箱
        industry: "", // 行业
        customerType: "", // 客户类别
        // 🔥从单个值改为数组（存储多选的产品）
        interestProducts: [],
        quantity: "", // 数量
        demand: "", // 需求描述
        allowContact: true, // 允许电话联系（默认勾选）
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        email: [{ required: true, validator: validateEmail, trigger: "blur" }],
        industry: [
          { required: true, message: "请选择行业", trigger: "change" },
        ],
        customerType: [
          { required: true, message: "请选择客户类别", trigger: "change" },
        ],
        // 产品校验规则（触发方式为change）
        interestProducts: [
          { required: true, validator: validateProducts, trigger: "change" },
        ],
        quantity: [
          { required: true, message: "请输入数量", trigger: "blur" },
          { type: "number", min: 1, message: "数量不能小于1", trigger: "blur" },
        ],
        demand: [{ message: "请描述您的需求", trigger: "blur" }],
      },

      // 所有规格
      productGroups: [], // 分类+产品的组合数组
    };
  },

  mounted() {
    this.dataGuige();
  },

  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit("close");
    },
    // 提交表单
    handleSubmit() {
      this.$refs.purchaseForm.validate((valid) => {
        if (valid) {
          // 校验通过，提交数据给父组件
          this.$emit("submit", this.form);
        } else {
          this.$message.error("请完善必填项后提交！");
          return false;
        }
      });
    },

    // 获取表单要显示的所有规格
    // 你的原始接口方法（修改后）
    dataGuige() {
      this.$post(
        "k=shangpin&c=allguige",
        // { id: this.sid },//传id就显示单个商品的，不传显示所有商品的规格
        (res) => {
          // 核心：把接口数据处理成模板需要的格式

          // 1. 把接口的对象格式转成数组格式
          const shuObj = res.shu;
          this.productGroups = Object.keys(shuObj).map((key) => {
            const category = shuObj[key];
            return {
              groupName: category.fenlei_yiji_ming, // 分类名
              products: category.list, // 该分类下的商品列表
            };
          });

          // 数据加载完成后更新Swiper（如果需要）
          // this.updateSwiper();
        },
        (err) => {
          // 可选：添加错误回调
          console.error("获取所有规格失败：", err);
        },
      );
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  top: 5vh;
  margin: 5vh auto;
  .purchase-form {
    padding: 0.2rem 0.5rem;
    padding-top: 0;
  }

  .el-dialog__header {
    padding: 0.1rem 0;
    padding-top: 0.3rem;
    text-align: center;
    .el-dialog__title {
      font-size: var(--font24);
      font-weight: bold;
    }
  }

  .el-dialog__body {
    padding: 0;
    padding-top: 0;

    .purchase-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .el-form-item {
        width: 48%;
        margin-bottom: 10px;

        .el-form-item__label {
          float: none;
        }

        .el-select {
          width: 100%;
        }

        &.xqshangpin {
          width: 100%;
          .product-group {
            display: flex;
            .group-label {
              flex-shrink: 0;
              line-height: 30px;
            }

            .el-checkbox-group {
              .el-checkbox {
                line-height: 30px;
              }
            }
          }
        }

        &.allow {
          margin-top: 0.1rem;
        }

        &.xq {
          width: 100%;
        }
      }
    }
  }

  .el-dialog__footer {
    padding: 0;
    padding-bottom: 0.2rem;
    text-align: center;
  }
}

@media screen and (max-width: 767px) {
  /deep/ .el-dialog {
    width: 94% !important;

    .el-dialog__body .purchase-form .el-form-item.xqshangpin .product-group {
      flex-wrap: wrap;
      .group-label {
        width: 100%;
      }
    }
  }
}
</style>
